<template>
  <v-dialog
    v-model="dialogComputed"
    @click:outside="$emit('close')"
    @keydown.esc="$emit('close')"
    width="400"
  >
    <v-row no-gutters class="dialog-container">
      <v-col cols="12" class="pr-4 d-flex flex-column">
        <h3 class="primary--text mb-4">{{ title }}</h3>
        <span v-html="subtitle" />
        <div class="mt-4 d-flex justify-end">
          <v-btn class="primary" @click="$emit('action')">{{
            $t("new-event.buttons.confirm")
          }}</v-btn>
          <v-btn class="ml-2 primary--text" outlined @click="$emit('close')">{{
            $t("new-event.buttons.cancel")
          }}</v-btn>
        </div>
      </v-col>
    </v-row>
  </v-dialog>
</template>

<script>
export default {
  name: "ConfirmAction",
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
  },
  computed: {
    dialogComputed: {
      get() {
        return this.dialog;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
};
</script>

<style scoped>
.dialog-container {
  background-color: #e9e8ed;
  padding: 24px;
  position: relative;
}
</style>
